import { defineOrgQuery } from '../shared/procedures';

export const viewerQueries = {
  profileRole: defineOrgQuery(({ ctx, orgQuery }) =>
    orgQuery('ProfileRole').where('profileId', ctx.profileId),
  ),
  teamMemberships: defineOrgQuery(({ ctx, orgQuery }) =>
    orgQuery('CoachTeamMembership').where('profileId', ctx.profileId),
  ),
  /**
   * SC-5685: the viewer's own ProfilePermission row (absent when none is
   * stored). Self-scoped, so the replica materializes exactly one permission
   * row — the viewer's — and never the org-wide permission matrix. Client
   * permission gates subscribe to it so a mid-session revocation hides data
   * live through IVM.
   */
  profilePermission: defineOrgQuery(({ ctx, orgQuery }) =>
    orgQuery('ProfilePermission').where('profileId', ctx.profileId),
  ),
  orgDefaultRole: defineOrgQuery(({ orgQuery }) => orgQuery('OrgSettings')),
};
